module.exports = __webpack_public_path__ + "img/sv73.479449be.svg";